import React, {useEffect, useState} from "react";

import {useSelector} from "react-redux";
import styled from "styled-components";
import TitleSection from "./TitleSection";
import {getDateInFrench} from "../../../utils/dateUtils";
import Objectives from "../../objective/Objectives";

const ObjectivesSection = ({
                               toggleHandler,
                               isInteractive
                           }) => {

    const {id: projectId, objectives} = useSelector(state => state.project)
    const [lastUpdate, setLastUpdate] = useState()
    const {projectHistory} = useSelector(state => state.projectHistory)

    useEffect(() => {
        const lastUpdateItems = projectHistory.filter(p => p.entityClass === "OKR")
        if (lastUpdateItems.length > 0) {
            setLastUpdate(lastUpdateItems[0])
        }
    }, [projectHistory])

    const displayOKRs = () => {
        return <Objectives
            objectives={objectives}
            isInteractive={isInteractive}
            projectId={projectId}
            inGuidedUpdate={true}
        />
    }

    const displayFirstSection = () => {
        if (isInteractive) {
            return (
                <>
                    <TitleSection
                        toggleHandler={toggleHandler}
                        title={"Objectifs et résultats"}
                    />
                    <Explanation>
                        <P>Les objectifs sont une réponse à : pourquoi faire ce projet ? </P>
                        <P>Les résultats seront les preuves possibles chiffrées dans chaque objectif (avec une
                            quantité
                            ou un pourcentage).
                        </P>
                    </Explanation>
                    <p> Dernière mise à jour
                        : {lastUpdate ? getDateInFrench(lastUpdate.dateOfModification) : "Aucune modification"}</p>
                </>
            )
        }
    }
    return (
        <Container>
            {displayFirstSection()}
            {displayOKRs()}
        </Container>

    )
}
const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`
const P = styled.p`
  text-align: center;
  margin-top: 0.5rem;
`
const Explanation = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 10px;
`
export default ObjectivesSection;